import { ShiftChangeStatusInterface } from '../../../interfaces/shift-change-status.interface';

export class SetAwaitingShiftStatus {
    public static readonly type = '[JobsPlacements] Set shift awaiting status';

    constructor(public data: ShiftChangeStatusInterface) {}
}
